import { render, staticRenderFns } from "./noice-charts.vue?vue&type=template&id=38f312ca&scoped=true"
import script from "./noice-charts.vue?vue&type=script&lang=js"
export * from "./noice-charts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f312ca",
  null
  
)

export default component.exports